export const API_URL = 'https://sisuper.kabngawi.id';
export const BASE_PATH = '/super/v1/landing';